import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { Container, Col, Row } from "react-bootstrap";
import AskFaq from "../../Images/askFaq.png";
import { format, parseISO } from 'date-fns';
import CompanyAbout from "./CompanyAbout/CompanyAbout";
import CompanyChart from "./CompanyChart/CompanyChart";
import PriceHistory from "./PriceHistory/PriceHistory";
import CompanyFundamentals from "./CompanyFundamentals/CompanyFundamentals";
import CompanyKeystat from './CompanyKeystat/CompanyKeystat';
import CompanyShareholding from './CompanyShareholding/CompanyShareholding';
import CompanyLogo from "../../Images/comlogo.png";
import Faq from "./CompanyFAQs/CompanyFAQs";
import SimilerEquities from "./SimilerEquities/SimilerEquities";
import "../CompanySnapshot/CompanySnapshot.css";
import URLstateContext from "../../provider/CommonContext";
import CompanyCorpaction from './CompanyCorpaction/CompanyCorpaction';
import PeerComparison from './PeerComparison/PeerComparison';
import GroupCompanies from './GroupCompanies/GroupCompanies';
import NewsEquity from './NewsEquity/NewsEquity';
import { Link, Element, Events, animateScroll as scroll, scroller, } from "react-scroll";
import { symbol } from "prop-types";
import CompanyChartFandO from "./CompanyChartFandO/CompanyChartFandO";
import { Vortex } from "react-loader-spinner";
import OptChain from "./OptChain/OptChain";
import { Modal } from "react-bootstrap";


function CompanySnapshotIframe() {
  const [show, setShow] = useState(false);
  const [showLoad, setShowLoad] = useState(false);
  const handleClose = () => setShowLoad(false);
  const handleShow = () => setShow(true);
  const handleShowLoad = () => setShowLoad(true);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [companyInfo, setCompanyInfo] = useState([]);
  const [type, settype] = useState('optc');
  const location = useLocation();
  const [isPreviewShown, setPreviewShown] = useState(false);
  const [loadingshow, setloadingshow] = useState(false);
  const { exchg, cocode, requestcompname } = useParams();
  const [compname, setcompname] = useState([]);
  const [data, setData] = useState([]);
  const [dataAll, setDataAll] = useState([]);
  const [dataExp, setDataExp] = useState([]);
  const [expiryDate, setExpiryDate] = useState([]);
  const [expiryDateFut, setExpiryDateFut] = useState([]);
  const [dataFandO, setDataFandO] = useState([]);
  const [dataExc, setDataExc] = useState([]);
  const [dataExpOpt, setDataExpOpt] = useState([]);
  const [optionType, setOptionType] = useState([]);
  const [dataStrikePrice, setDataStrikePrice] = useState([]);
  const [dataOptType, setDatapOptType] = useState([]);
  const [expOptions, setExpOptions] = useState([]);
  const [valueInstr, setValueInstr] = useState([]);
  const [dataNSE, setDataNSE] = useState([]);
  const [symbolFandO, setSymbolFandO] = useState([]);
  const [co_code, setco_code] = useState([]);
  const [urlStr, setUrlStr] = useState('');
  const [valueExpDate, setValueExpDate] = useState([]);
  const [valueInstrument, setValueInstrument] = useState([]);
  const [valueExpDateFinal, setValueExpDateFinal] = useState([]);
  const [Exchng, setExchng] = useState('NSE');
  const [exchange, setexchange] = useState([]);
  const [FandO, setFandO] = useState(['select_FandO']);
  const [dateExp, setDateExp] = useState([]);
  const [strikePrice, setStrikePrice] = useState([]);
  const [instrText, setInstrText] = useState([]);
  const [ExchangeBSE, setexchangeBSE] = useState('');
  const [ExchangeNSE, setexchangeNSE] = useState('');
  const [ExchangeFnO, setexchangeFnO] = useState('');
  useEffect(() => {
    setexchange('NSE');
    clickexchgHandler('NSE');
  }, []);





  let getcompname, getData, getDataExp, instrValue, expDateDD, getDataNSE,
    expDateOptions, getDataExpOpt, getDataExpOptType, strikePriceDD, getDataExc,
    getDataStrikePrice, getDataFandO, optionTypeDD, getDataFandOFinal;
  const childRef = useRef(null);
  const childRefpricehistory = useRef(null);
  const childRefsimilarstocks = useRef(null);
  const childRefpeer = useRef(null);
  const { BaseURL, compserachcocode } = useContext(URLstateContext);

  var elementLi = document.getElementById('liFandO');
  var eleLi = document.getElementById('liNSE');
  var eleLiBse = document.getElementById('liBSE');
  var eleLiGet = document.getElementById('liGetQuote');

  function openModal() {
    setIsOpen(true);
  }
  const handleClosePopup = () => {
    setShow(false);
  }

  useEffect(() => {
    const getUrlchart = BaseURL + "getCo_Code_Iframe";
    fetch(`${getUrlchart}/${requestcompname}`)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data.data)
        setDataAll(data.data);
        setco_code(data.data[0]["co_code"]);
        getcompname = data.data[0]["lname"];
        // setexchange(data.data[0]["exchg"]);
        setcompname(getcompname);
        setFandO(data.data[0]["symbol"]);
      })
      .catch((error) => {
        //console.log("not found the api");
      });

    const getUrl = BaseURL + "listed_Iframe";
    fetch(`${getUrl}/${requestcompname}`)
      .then((response) => response.json())
      .then((dataL) => {
        setexchangeBSE(dataL.data[0]["BSE_exchg"]);
        setexchangeNSE(dataL.data[0]["NSE_exchg"]);
        setexchangeFnO(dataL.data[0]["NSE_Fao"]);
      })
      .catch((error) => {
        //console.log("not found the api");
      });

  }, []);


  useEffect(() => {
    document.getElementById('chartComponentFandO').style.display = "none";
    //console.log("co_code 2:" + co_code);
    // getGetQuoteDetails(co_code, exchg);
    const getUrl = BaseURL + "GetQuoteDetails/";
    if (co_code != "") {
      fetch(`${getUrl}/${co_code}/-`)
        .then((response) => response.json())
        .then((data) => {
          getData = data.data;
          setData(getData);
          //console.log(getData);
          setSymbolFandO(data.data[0]["symbol"]);

        })
        .catch((error) => {
          //console.log("not found the api 1233333");
        });
    }
    if (ExchangeNSE != '' && ExchangeBSE != '' && ExchangeFnO != '') {
      if (ExchangeNSE === "NSE" && ExchangeBSE === "BSE" && ExchangeFnO === "FAO") {
        setexchange("NSE");
        // setloadingshow(false);
      }
      else if (ExchangeNSE === "NSE" && ExchangeBSE === "not" && ExchangeFnO === "FAO") {
        setexchange("NSE");
        // setloadingshow(false);
      }
      else if (ExchangeNSE === "not" && ExchangeBSE === "BSE" && ExchangeFnO === "FAO"){
        setexchange("BSE");
        // setloadingshow(false);
      }
      else if (ExchangeNSE === "not" && ExchangeBSE === "not" && ExchangeFnO === "FAO"){
        setexchange("FnO");
       // setloadingshow(false);
      }
      else if (ExchangeNSE === "NSE" && ExchangeBSE === "BSE" && ExchangeFnO === "not"){
        setexchange("NSE");
        //setloadingshow(false);
      }
      else if (ExchangeNSE === "not" && ExchangeBSE === "BSE" && ExchangeFnO === "not"){
        setexchange("BSE");
        //setloadingshow(false);
      }
      else if (ExchangeNSE === "NSE" && ExchangeBSE === "not" && ExchangeFnO === "not"){
        setexchange("NSE");
        //setloadingshow(false);
      }
    }
  }, [co_code]);


  function getGetQuoteDetails(compcocode, exchange) {
    const getUrl = BaseURL + "GetQuoteDetails/";

    if (co_code != "") {
      fetch(`${getUrl}/${co_code}/${exchange}`)
        .then((response) => response.json())
        .then((data) => {
          getData = data.data;
          setData(getData);
          //console.log(getData);
          setSymbolFandO(data.data[0]["symbol"]);

        })
        .catch((error) => {
          //console.log("not found the api 1233333");
        });
    }

  }

  var uStr = ""

  const clickexchgHandlerFandO = () => {
    if (elementLi != null) elementLi.classList.add('active');
    if (eleLi != null) eleLi.classList.remove('active');
    if (eleLiBse != null) eleLiBse.classList.remove('active');
    if (eleLiGet != null) eleLiGet.classList.remove('active');
    document.getElementById('select').value = "futures";
    var eleInstr = document.getElementById("select");
    // var textInstr = eleInstr.options[eleInstr.selectedIndex].text;
    // setInstrText(textInstr);
    var textInstr = "Futures";
    setInstrText(textInstr);
    var instr_value = eleInstr.children[1].value;
    setValueInstrument(instr_value);
    setValueInstr(instr_value);
    //console.log(instr_value);
    if (instr_value === "futures") {
      const getUrlExpiry = BaseURL + "FandOExpiryDate/";
      fetch(`${getUrlExpiry}/FUTSTK/${symbolFandO}`)
        .then((response) => response.json())
        .then((dataExp) => {
          getDataExp = dataExp.data;
          setDataExp(getDataExp);
          // console.log(getDataExp); 
          var expDate = getDataExp[0].ExpDate;
          setValueExpDate(expDate);
          setValueExpDateFinal(expDate.replace(/\//g, "-"))
        })
        .catch((error) => {
          // console.log("not found the api 1233333");
        });
    }

    uStr = ''
    setloadingshow(true);
    document.getElementById('chartComponent').style.display = "none";
    document.getElementById('chartComponentFandO').style.display = "block";
    setPreviewShown(true);
    document.getElementById('FandO_Section').style.display = "block";
    document.getElementById('FandO_Option_Section').style.display = "none";
    const elExpOptions = document.querySelectorAll('.select_expdate_options');
    const elOptionType = document.getElementById('select_option_type')
    const el = document.getElementById('select');
    const optionData = document.getElementById('FandO_Option_Section');

    elOptionType.addEventListener('change', function handleChange(event) {
      let option_type = event.target.value;
      setOptionType(event.target.value);
      setloadingshow(true);
      handleShowLoad();
      setTimeout(() => {
        document.getElementById('submitButton').click();
      }, 1000)
    });

    el.addEventListener('change', function handleChange(event) {
      setloadingshow(true);
      uStr = ''
      instrValue = event.target.value;
      setValueInstr(instrValue);
      if (event.target.value === 'options') {
        setInstrText()
        setPreviewShown(false);
        uStr = ''
        setloadingshow(true);
        optionData.style.display = 'block';
        const getUrlExpiry = BaseURL + "FandOExpiryDate/";
        fetch(`${getUrlExpiry}/OPTSTK/${symbolFandO}`)
          .then((response) => response.json())
          .then((dataExpOpt) => {
            getDataExpOpt = dataExpOpt.data;
            setDataExpOpt(getDataExpOpt);
            // console.log(getDataExp);
          })
          .catch((error) => {
            //console.log("not found the api 1233333");
          });
        const getUrlExpiryOption = BaseURL + "OptionType/";
        fetch(`${getUrlExpiryOption}/opTIDX`)
          .then((response) => response.json())
          .then((dataOpt) => {
            getDataExpOptType = dataOpt.data;
            setDatapOptType(getDataExpOptType);
            // console.log(getDataExpOptType);
            setloadingshow(true);
          })
          .catch((error) => {
            //console.log("not found the api 1233333");
          });

      } else {

        setPreviewShown(true);
        uStr = ''
        optionData.style.display = 'none';
        const getUrlExpiry = BaseURL + "FandOExpiryDate/";
        fetch(`${getUrlExpiry}/FUTSTK/${symbolFandO}`)
          .then((response) => response.json())
          .then((dataExp) => {
            getDataExp = dataExp.data;
            setDataExp(getDataExp);
            // console.log(getDataExp); 

          })
          .catch((error) => {
            // console.log("not found the api 1233333");
          });
      }

    });

  }


  const clickexchgHandler = (excgh) => {
    setValueInstr('');
    setloadingshow(false);
    document.getElementById('chartComponent').style.display = "block";
    document.getElementById('chartComponentFandO').style.display = "none";
    //alert("wait patiently I am still working on it");
    childRef.current.chnageexchnage(excgh, co_code);
    setPreviewShown(false);
    childRefpricehistory.current.chnageexchnagepricehistory(excgh);
    childRefsimilarstocks.current.chnageexchnagesimilarstocks(excgh);
    setexchange(excgh);
    getGetQuoteDetails(co_code, excgh);
    document.getElementById('FandO_Section').style.display = "none";
    document.getElementById('FandO_Option_Section').style.display = "none";
    var elementLi = document.getElementById('liFandO');
    if (excgh === 'NSE') {
      if (eleLi != null) eleLi.classList.add('active');
      if (eleLiBse != null) eleLiBse.classList.remove('active');
      if (elementLi != null) elementLi.classList.remove('active');
      if (eleLiGet != null) eleLiGet.classList.remove('active');
    } else if (excgh === 'BSE') {
      if (eleLiBse != null) eleLiBse.classList.add('active');
      if (eleLi != null) eleLi.classList.remove('active');
      if (elementLi != null) elementLi.classList.remove('active');
      if (eleLiGet != null) eleLiGet.classList.remove('active');
    }

  };


  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const handleScroll = (e) => {
    if (dataAll != null) {
      const fixsc = document.querySelector(".company-fundamental-sectionKey");
      const scrollTop = window.scrollY;
      scrollTop >= 150
        ? fixsc.classList.add("col-sticky")
        : fixsc.classList.remove("col-sticky");

      const bottom =
        e.target.scrollingElement.scrollHeight -
        e.target.scrollingElement.scrollTop < 400

      // console.log(e);
      
      if (bottom) {
        fixsc.classList.remove("col-sticky");
      }
    }
  }
  useEffect(() => {

    window.addEventListener("scroll", snapshottabscroll);
    return () => {
      window.removeEventListener("scroll", snapshottabscroll);
    };

  });
  const snapshottabscroll = (e) => {
    const fixsc = document.querySelector(".company-snap-tabs");
    const scrollTop = window.scrollY;
    scrollTop >= 150
      ? fixsc.classList.add("tab-sticky_iframe_Comp")
      : fixsc.classList.remove("tab-sticky_iframe_Comp");

  }

  const handleSubmit = () => {
    const getUrlStrikePrice = BaseURL + "StrikePrice";
    fetch(`${getUrlStrikePrice}/STKPRICE/-/${symbolFandO}/OPTSTK/${expiryDate}/${optionType}`)
      .then((response) => response.json())
      .then((dataStrikePrice) => {
        getDataStrikePrice = dataStrikePrice.data;
        setDataStrikePrice(getDataStrikePrice);
        setloadingshow(false);
        handleClose();
        // console.log(dataStrikePrice);
      })
      .catch((error) => {
        //console.log("not found the api 1233333");
      });

    const getUrlQuote = BaseURL + "GetQuoteDerivativesFandO";
    //alert(`${getUrlQuote}/GQ/${expiryDate}/OPTSTK/${symbolFandO}/${optionType}/${strikePrice}`)
    fetch(`${getUrlQuote}/GQ/${expiryDate}/OPTSTK/${symbolFandO}/${optionType}/${strikePrice}`)
      .then((response) => response.json())
      .then((dataFandO) => {
        getDataFandO = dataFandO.data;
        setDataFandO(getDataFandO);
        // console.log(dataFandO);
      })
      .catch((error) => {
        //console.log("not found te api 1233333");
      });

  }

  const clickGetQuotes = () => {
    if (elementLi != null) elementLi.classList.remove('active');
    if (eleLi != null) eleLi.classList.remove('active');
    if (eleLiBse != null) eleLiBse.classList.remove('active');
    if (eleLiGet != null) eleLiGet.classList.add('active');
    window.open("/CompanyProfile/Company-Background/" + requestcompname, '_blank');
  }

  return (
    <>
      <section className="">

        <Container className="company-snap-tabs">
          <Row>
            <nav className="company-snap">
              <ul className="ulsnap">
                <li>
                  <Link to="section-1" spy={true} smooth={true}>
                    Company Chart
                  </Link>
                </li>
                <li>
                  <Link to="section-2" spy={true} smooth={true}>
                    Price History
                  </Link>
                </li>
                <li>
                  <Link to="section-3" spy={true} smooth={true}>
                    Holdings
                  </Link>
                </li>
                <li>
                  <Link to="section-4" spy={true} smooth={true}>
                    Corporate Actions
                  </Link>
                </li>
                <li>
                  <Link to="section-5" spy={true} smooth={true}>
                    Peer Comparison
                  </Link>
                </li>
                <li>
                  <Link to="section-6" spy={true} smooth={true}>
                    Group Companies
                  </Link>
                </li>
                <li>
                  <Link to="section-7" spy={true} smooth={true}>
                    Similar Equities
                  </Link>
                </li>

                <li>
                  <Link to="section-9" spy={true} smooth={true}>
                    News
                  </Link>
                </li>
                <li>
                  <Link to="section-8" spy={true} smooth={true}>
                    FAQ
                  </Link>
                </li>
              </ul>
            </nav>
          </Row>
        </Container>
        {(dataAll != null) ?
          <Container>
            <Row>
              <Col md={8}>
                <main className="react-scroll-page">
                  <section className="company-chart-section">

                    <div className="company-details-block">
                      {/* {data != null && data.map((eachData) => (
                      <> */}
                      <div className="company-name">
                        <h1>
                          <img src={CompanyLogo} alt="CompanyLogo-img" />
                          &nbsp;
                          {data != null && data.map((eachData) => (

                            <span>{eachData.complname}</span>
                          ))}
                        </h1>
                        <ul className="headingComp">
                          {(ExchangeNSE === "NSE") ?
                            <li id="liNSE"
                              className={(exchange === "NSE") ? 'active' : ''}
                              onClick={() => clickexchgHandler('NSE')}
                            >
                              <span>NSE</span>
                            </li> : ''}
                          {(ExchangeBSE === "BSE") ?
                            <li id="liBSE"
                              className={(exchange === "BSE") ? 'active' : ''}
                              onClick={() => clickexchgHandler('BSE')}
                            >
                              <span>BSE</span>
                            </li> : ''}
                         
                        </ul>
                        <div id="FandO_Section">
                          <div id="FandO_Section1" className="fno-dropdown">
                            <select id="select">
                              <option value="select_Instrument">Select Instrument</option>
                              <option value="futures" selected="selected">Futures</option>
                              <option value="options">Options</option>
                            </select>
                          </div>
                          {isPreviewShown &&
                            <div id="FandO_Section2" className="fno-dropdown">
                              <select id="select_expdate_futures" onChange={(event) => setExpiryDateFut(event.target.value)}>
                                <option value="select_ExpiryDate">Select Expiry Date</option>
                                {dataExp && dataExp.map(({ ExpDate }) => (
                                  <option value={ExpDate} selected={valueExpDate == ExpDate}>{ExpDate}</option>
                                )
                                )}
                              </select> </div>}
                          {(valueInstr === 'options') ?
                            <><div id="FandO_Section3" className="fno-dropdown">
                              <select className="select_expdate_options" onChange={(event) => setExpiryDate(event.target.value)}>
                                <option value="select_ExpiryDate">Select Expiry Date</option>
                                {dataExpOpt && dataExpOpt.map(({ ExpDate }) => (
                                  <option value={ExpDate}>{ExpDate}</option>
                                )
                                )}
                              </select></div></> : ''}
                          <div className='dtopt-call-toggleChain'>
                            <button id="btnGain" value="optc" onClick={handleShow}>Option Chain</button>
                          </div>
                        </div>
                        <Modal show={show} className="modal company-snap-modalOpt">
                          <Modal.Body id="modal_infoComp">
                            <div className="btnDiv">
                              <div className="btnclFandO" onClick={handleClosePopup} > X </div>
                            </div>
                            <div className="ttinfoCompany"><OptChain symbolFandO={symbolFandO} /></div>
                          </Modal.Body>
                        </Modal>

                        <div id="FandO_Option_Section">
                          <div id="FandO_Option_Section1" className="fno-dropdown">
                            <select className="select_expdate_options" id="select_option_type">
                              <option value="select_Instrument">Select Option Type</option>
                              {dataOptType && dataOptType.map(({ opttype }) => (
                                <option value={opttype}>{opttype}</option>
                              )
                              )}
                            </select>
                          </div>
                          <div id="FandO_Option_Section2" className="fno-dropdown">
                            <select className="select_expdate_options" onChange={(event) => setStrikePrice(event.target.value)}>
                              <option value="select_strike_price">Select Strike Price</option>
                              {dataStrikePrice && dataStrikePrice.map(({ StrikePrice }) => (
                                <option value={StrikePrice}>{StrikePrice}</option>
                              )
                              )}
                            </select>
                            {loadingshow ?
                              <Modal show={showLoad} className="modal company-snap-modalOpt loaderComp">
                                <Modal.Body id="modal_infoComp">
                                  <div className="textcentervertex">
                                    <Vortex
                                      visible={true}
                                      height="80"
                                      width="80"
                                      ariaLabel="vortex-loading"
                                      wrapperStyle={{}}
                                      wrapperClass="vortex-wrapper"
                                      colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                  </div>
                                </Modal.Body>
                               </Modal> 
                              : "" }
                          </div>
                        </div>
                        <button id="submitButton" onClick={() => handleSubmit()}></button>
                      </div>
                      <div className="company-share-details">
                        {data != null && data.map((eachData) => (
                          <>
                            <span>Share Price</span>
                            <h4>{(eachData.price != null) ? eachData.price.toFixed(2) : eachData.price = 0}</h4>
                            <small
                              className={
                                eachData.pricediff > 0 ? "textGreen" : "textRed"
                              }
                            >
                              {(eachData.pricediff != null) ? eachData.pricediff.toFixed(2) : eachData.pricediff = 0} (
                              {(eachData.change != null) ? eachData.change.toFixed(2) : eachData.change = 0}%)
                            </small>
                          </>
                        ))}
                      </div>
                    </div>
                  </section>
                  <Element name="section-1" className="page-section page-section-1" id="chartComponent">
                    <CompanyChart name="section-1" className="page-section page-section-1" exchange={exchange} coCode={co_code} ref={childRef} />
                  </Element>
                  <Element name="section-0" className="page-section page-section-0" id="chartComponentFandO">
                    <CompanyChartFandO name="section-0" className="page-section page-section-0" exchange={exchange} coCode={co_code} ref={childRef} symbolFandO={symbolFandO} expiryDateFut={expiryDateFut} expiryDate={expiryDate} optionType={optionType} strikePrice={strikePrice} valueInstr={valueInstr} valueInstrument={valueInstrument} instrText={instrText} valueExpDateFinal={valueExpDateFinal} />
                  </Element>
                  <Element name="section-2" className="page-section page-section-2">
                    <PriceHistory exchange={exchange} coCode={co_code} compname={compname} ref={childRefpricehistory} />
                  </Element>
                  <Element name="section-3" className="page-section page-section-3">
                    <CompanyShareholding coCode={co_code} />
                  </Element>
                  <Element name="section-4" className="page-section page-section-4">
                    <CompanyCorpaction coCode={co_code} />
                  </Element>
                  <Element name="section-5" className="page-section page-section-5">
                    <PeerComparison coCode={co_code} exchange={exchange} />
                  </Element>
                  <Element name="section-6" className="page-section page-section-6">
                    <GroupCompanies coCode={co_code} />
                  </Element>
                  <Element name="section-7" className="page-section page-section-7">
                    <SimilerEquities exchange={exchange} coCode={co_code} ref={childRefsimilarstocks} />
                  </Element>
                  <Element name="section-9" className="page-section page-section-9">
                    <NewsEquity coCode={co_code} requestcompname={requestcompname} />
                  </Element>
                  <Element name="section-8" className="page-section page-section-8">
                    <Faq exchange={exchange} coCode={co_code} ref={childRef} compname={compname} valueInstr={valueInstr} ExchangeNSE={ExchangeNSE} />
                  </Element>
                </main>
              </Col>
              <Col md={4}>
                <CompanyKeystat coCode={co_code} onScroll={handleScroll} />
              </Col>
            </Row>
          </Container> 
          : <div className="compInfoMain">
            <div className="textErrorDiv">Uh Oh! 404</div>
            <h1>Page Not Found</h1>
            <a href="/">Go to Home Page</a>
          </div>
          }
      </section>


    </>
  );
}

export default CompanySnapshotIframe;
